export default {
  width: '310px',
  marginRight: '0px',
  justifyContent: 'space-around',
  maxHeight: '30px',
}
